import React from 'react';
import { chargeNotice, companyRows, contactRows } from '../data/company';
import { InfoTable } from './InfoTable';
import { Notice } from './Notice';
import { Section } from './Section';
export function CompanySection() {
  return <Section id="empresa" number="01" title="Datos de la empresa" subtitle="Datos completos del vendedor. Son los mismos que figuran en nuestros documentos de constitución, en nuestras cuentas de pago y bancarias, en nuestras tiendas online y en los recibos que reciben los clientes." data-id="element-26" data-mp="1liu829ph64zc">
      <div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-2" data-id="element-27" data-mp="1qe9mb2rea2wa">
        <InfoTable rows={companyRows} caption="Datos legales de Massive Faith LLC" data-id="element-28" data-mp="246fsbw0u2ti0" />
        <InfoTable rows={contactRows} caption="Datos de contacto y cobro" data-id="element-29" data-mp="1z9pbv7l49vw2" />
      </div>
      <Notice text={chargeNotice} tone="ok" data-id="element-30" data-mp="2e559tnotibxq" />
    </Section>;
}